<template>
  <TableBasicPreview :data="tableData" />
</template>

<script>
import TableBasicPreview from '@/components/table/BasicPreview.vue';

export default {
  name: 'DistributorDetails',
  components: {
    TableBasicPreview,
  },
  props: {
    distributor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tableData() {
      return ([
        {
          label: this.$t('contactDetailsPreviewLabelDistributor'),
          info: this.distributor.legal_name,
        },
        {
          label: this.$t('contactDetailsPreviewLabelCity'),
          info: this.distributor.city,
        },
        {
          label: this.$t('contactDetailsPreviewLabelZip'),
          info: this.distributor.zip,
        },
        {
          label: this.$t('contactDetailsPreviewLabelAddress'),
          info: this.distributor.address,
        },
        {
          label: this.$t('contactDetailsPreviewLabelPhone'),
          info: this.distributor.phone,
        },
        {
          label: this.$t('contactDetailsPreviewLabelFax'),
          info: this.distributor.fax,
        },
        {
          label: this.$t('contactDetailsPreviewLabelEmail'),
          info: this.distributor.email,
        },
        {
          label: this.$t('contactDetailsPreviewLabelWebsiteLink'),
          info: this.distributor.web,
          link: true,
        },
      ]);
    },
  },
};
</script>
